"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
var _axios = _interopRequireDefault(require("axios"));
var _elementUi = require("element-ui");
var _store = _interopRequireDefault(require("@/store"));
var hasResetToken = false;
var requestsList = [];
// create an axios instance
var service = _axios.default.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000 // request timeout
});

// request interceptor
service.interceptors.request.use(function (config) {
  config.params && Object.keys(config.params).forEach(function (key) {
    if (config.params[key] === '') {
      config.params[key] = null;
    }
  });
  config.headers['Authorization'] = _store.default.getters.token;
  return config;
}, function (error) {
  // do something with request error
  console.log(error); // for debug
  return Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(
/*#__PURE__*/
/**
 * If you want to get http information such as headers or status
 * Please return  response => response
*/
/**
 * Determine the request status by custom code
 * Here is just an example
 * You can also judge the status by HTTP Status Code
 */
function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(response) {
    var res, _response$config, method, params;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          console.log('请求地址:', response.config.url, ' | GET参数:', response.config.params || '空', 'POST参数:', response.config.data || '空');
          res = response.data;
          _response$config = response.config, method = _response$config.method, params = _response$config.params;
          if (method === 'get' && params && params.limit && params.limit < 500) {
            window.scrollTo(0, 0);
          }
          if (!(res.code !== 0 && res.code !== 200)) {
            _context.next = 22;
            break;
          }
          if (!(res.code === 1003 || res.code === 1004)) {
            _context.next = 19;
            break;
          }
          if (!response.config.url.includes('logout')) {
            _context.next = 8;
            break;
          }
          return _context.abrupt("return");
        case 8:
          if (hasResetToken) {
            _context.next = 18;
            break;
          }
          hasResetToken = true;
          _context.next = 12;
          return _store.default.dispatch('user/ticketLogin');
        case 12:
          requestsList.forEach(function (cb) {
            return cb();
          });
          hasResetToken = false;
          requestsList = [];
          return _context.abrupt("return", service.request(response.config));
        case 18:
          return _context.abrupt("return", new Promise(function (resolve) {
            requestsList.push(function () {
              resolve(service(response.config));
            });
          }));
        case 19:
          if ([1002, 1021, 1023].includes(res.code)) {
            _store.default.dispatch('user/resetToken').then(function () {
              location.reload();
            });
            (0, _elementUi.Message)({
              message: res.msg || 'Error',
              type: 'error',
              duration: 5 * 1000
            });
          }
          if (typeof res.msg === 'string') {
            if (res.msg.startsWith('[')) {
              res.msg = JSON.parse(res.msg);
            }
          } else {
            res.msg = JSON.stringify(res.msg);
          }
          (0, _elementUi.Message)({
            message: '失败：' + res.msg || 'Error',
            type: 'error',
            duration: 3 * 1000
          });
        case 22:
          if (!(res.code !== 0)) {
            _context.next = 26;
            break;
          }
          return _context.abrupt("return", Promise.reject(res));
        case 26:
          return _context.abrupt("return", res);
        case 27:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}(), function (error) {
  console.log(error); // for debug
  (0, _elementUi.Message)({
    message: error.message,
    type: 'error',
    duration: 2 * 1000
  });
  return Promise.reject(error);
});
var _default = service;
exports.default = _default;